var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"not-found-content"},[_c('h1',{staticClass:"error-code"},[_vm._v("404")]),_c('p',{staticClass:"error-message"},[_vm._v("Oops! The page you're looking for can't be found.")]),_c('router-link',{staticClass:"back-home-btn",attrs:{"to":"/"}},[_vm._v("Go Back Home")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }